/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import {
  OktaResourceConnectionServer,
  OktaResourceConnectionServer$inboundSchema,
} from "./oktaresourceconnectionserver.js";

export type ListOktaResourceConnectionsResult = {
  /**
   * Whether the connection has an AI agent recorded; every server needs one first.
   */
  agentRecorded: boolean;
  /**
   * The organization's identity provider connection.
   */
  connectionId?: string | undefined;
  /**
   * Link to the add-resource-connection form of the AI agent in the identity provider console. Omitted until an agent is recorded or when the org uses a custom domain.
   */
  deepLink?: string | undefined;
  /**
   * Servers that still need a step.
   */
  pendingCount: number;
  /**
   * Pending servers first, then by name. By default only servers with a step left; include_all adds connected, verified and not-applicable ones.
   */
  servers: Array<OktaResourceConnectionServer>;
  /**
   * Eligible servers before filtering.
   */
  totalCount: number;
  /**
   * Servers left out because their authorization server metadata has not been fetched yet.
   */
  undiscoveredCount: number;
};

/** @internal */
export const ListOktaResourceConnectionsResult$inboundSchema: z.ZodMiniType<
  ListOktaResourceConnectionsResult,
  unknown
> = z.pipe(
  z.object({
    agent_recorded: z.boolean(),
    connection_id: z.optional(z.string()),
    deep_link: z.optional(z.string()),
    pending_count: z.int(),
    servers: z.array(OktaResourceConnectionServer$inboundSchema),
    total_count: z.int(),
    undiscovered_count: z.int(),
  }),
  z.transform((v) => {
    return remap$(v, {
      "agent_recorded": "agentRecorded",
      "connection_id": "connectionId",
      "deep_link": "deepLink",
      "pending_count": "pendingCount",
      "total_count": "totalCount",
      "undiscovered_count": "undiscoveredCount",
    });
  }),
);

export function listOktaResourceConnectionsResultFromJSON(
  jsonString: string,
): SafeParseResult<ListOktaResourceConnectionsResult, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => ListOktaResourceConnectionsResult$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'ListOktaResourceConnectionsResult' from JSON`,
  );
}
